const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
// @ commons
const { formatText } = require('core/i18n').i18n;
// @ helpers
const { countActiveFilters } = require('utilities/filtersHelper');
// @ constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');

class ExtractsFilterTag extends React.Component {
    buildDateFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immFilterDate = immFilter.get('date');
        let labelFromDate = immFilterDate.get('from') ? immFilterDate.get('from').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)) : '';
        let labelToDate = immFilterDate.get('to') ? immFilterDate.get('to').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)) : '';
        if (labelFromDate && !labelToDate) {
            labelFromDate = formatText('datePickerCustom-from') + ': ' + labelFromDate
        }
        if (!labelFromDate && labelToDate) {
            labelToDate = formatText('datePickerCustom-to') + ': ' + labelToDate
        }
        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => resetFilter('date')}
            />
        );
    }

    buildContractFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const value = immFilter.getIn(['contract', 'number']);

        return (
            <LabelFilterRange
                key="filter-contract"
                from={value}
                closeCallback={() => resetFilter('contract')}
            />
        );
    }

    buildAccountFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const value = immFilter.getIn(['account', 'number']);

        return (
            <LabelFilterRange
                key="filter-contract"
                from={value}
                closeCallback={() => resetFilter('account')}
            />
        );
    }

    createButtonClearAllFilters() {
        const { immFilter, onClearFilter } = this.props;
        let response;

        if (countActiveFilters(immFilter) > 1) {
            response = <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={onClearFilter} />;
        }

        return response;
    }

    render() {
        const { immFilter } = this.props;
        const immFilterDate = immFilter.get('date');
        const immFilterContract = immFilter.get('contract');
        const immFilterAccount = immFilter.get('account');
        const filterDateLabel = immFilterDate.get('isActive') ? this.buildDateFilterLabel() : '';
        const filterContract = immFilterContract.get('isActive') ? this.buildContractFilterLabel() : '';
        const filterAccount = immFilterAccount.get('isActive') ? this.buildAccountFilterLabel() : '';
        const clearAllFiltersButton = this.createButtonClearAllFilters();

        return (
            <div className="extracts-filter-tag">
                {filterDateLabel}
                {filterContract}
                {filterAccount}
                {clearAllFiltersButton}
            </div>
        );
    }
}

ExtractsFilterTag.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onClearFilter: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired
}

module.exports = ExtractsFilterTag;
